/* eslint-disable import/prefer-default-export */
import Vue from "vue";
import { store } from "../../store/store";

export const paymentFunctions = new Vue({
  methods: {
    pay(price, orderId) {
      const options = {
        KEY: "rzp_test_AjocUgoR0LFdFk", // 'rzp_live_Im4Cag6lCnir7B', // 'rzp_live_AzVnT7Wt6AR1MZ',
        amount: price * 100,
        // amount: 100,
        name: "Edfore",
        description: "Subscription Payment",
        order_id: orderId,
        image:
          "https://banner2.kisspng.com/20180605/gqg/kisspng-lower-columbia-college-higher-education-school-sch-education-png-5b1706bc1306f0.112211061528235708078.jpg",
        callback_url: "",
        redirect: false,
        handler(response) {
          console.log(response);
          store.dispatch("user/setPaymentDetails", response);
        },
        prefill: {
          name: store.state.user.userData.name,
          email: store.state.user.userData.email,
          contact: store.state.user.userData.phone
        },
        notes: {
          address: "Hello World"
        },
        theme: {
          color: "#1c3774"
        }
      };
      const rzp1 = new Razorpay(options);
      rzp1.open();
    }
  }
});
